var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12121 2.6665C3.31789 2.6665 2.66667 3.31773 2.66667 4.12105V7.03014C2.66667 7.83346 3.31789 8.48469 4.12121 8.48469H8.28402L7.17231 9.59639C6.98297 9.78574 6.98297 10.0927 7.17231 10.2821C7.36166 10.4714 7.66864 10.4714 7.85799 10.2821L9.79738 8.34268C9.88831 8.25175 9.93939 8.12843 9.93939 7.99984C9.93939 7.87125 9.88831 7.74792 9.79738 7.657L7.85799 5.7176C7.66865 5.52826 7.36166 5.52826 7.17231 5.7176C6.98297 5.90695 6.98297 6.21394 7.17231 6.40328L8.28402 7.51499H4.12121C3.85344 7.51499 3.63636 7.29791 3.63636 7.03014V4.12105C3.63636 3.85328 3.85344 3.6362 4.12121 3.6362H11.8788C12.1466 3.6362 12.3636 3.85327 12.3636 4.12105V11.8786C12.3636 12.1464 12.1466 12.3635 11.8788 12.3635H4.12121C3.85344 12.3635 3.63636 12.1464 3.63636 11.8786V10.9089C3.63636 10.6412 3.41929 10.4241 3.15151 10.4241C2.88374 10.4241 2.66667 10.6412 2.66667 10.9089V11.8786C2.66667 12.6819 3.31789 13.3332 4.12121 13.3332H11.8788C12.6821 13.3332 13.3333 12.6819 13.3333 11.8786V4.12105C13.3333 3.31773 12.6821 2.6665 11.8788 2.6665H4.12121Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.969ef6e311ac7c7e839916c2533245f7.svg";
export { ForwardRef as ReactComponent };